/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'managemenu'} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">調理名登録画面</p>
                </div>
            </div>
        </div>
        <TyoriSetting />
    </div>

</template>

<script>
    import TyoriSetting from '@/app/components/TyoriSetting.vue'
    export default {
        name: 'manageTyoriSetting',
        components: {
            TyoriSetting
        }
    }
</script>
